export const TABLE_CELL_STYLES_DESKTOP = 'd-none d-print-block d-lg-table-cell';
export const TABLE_CELL_STYLES_DESKTOP_AND_MOBILE = 'd-print-block';
export const TABLE_CELL_STYLES_MOBILE = 'd-lg-none d-print-none';
export const TABLE_CELL_STYLES_DESKTOP_ALIGNMENT =
  'd-none d-print-block d-lg-table-cell text-center';
export const TABLE_CELL_STYLES_TABLET_ALIGNMENT = 'd-none d-md-table-cell';
